import React from 'react'
import { Table  } from 'antd';
import Main from '../../cpn/Main'
import { wechatList } from './wechatList'
function WorkWechatList() {   
    const columns = [
        {
            title: '微信昵称',
            dataIndex: 'name',
        },
        {
            title: '手机号码',
            dataIndex: 'phone',
        },
        {
            title: '备注',
            dataIndex: 'content',
        },       
    ]
    return (
        <Main selectedKeys={['/WorkWechatList']}  >
            <Table 
                dataSource={wechatList} 
                columns={columns} 
                size='small'
                rowKey='id'
            />
        </Main>
    )
}

export default WorkWechatList